import React from 'react'
import ListingListContainer from '../../templates/listing-list/ListingListContainer'
import withParams from '../../../modules/router-manage/withParams'
import TownHeader from '../../templates/navbar/TownHeader'
import Navbar from '../../templates/navbar/Navbar'
import ListingHeader from '../../templates/navbar/ListingHeader'
import ListingListActionPanel from '../../templates/listing-list/ListingListActionPanel'

const ListingListPage = props => (
  <div>
    <Navbar />
    <div className="container">
      <div className="section">
        <TownHeader params={props.params} />
        <ListingHeader />
        <ListingListActionPanel />
        <hr />
        <ListingListContainer {...props} />
      </div>
    </div>
  </div>
)

export default withParams(ListingListPage)



// WEBPACK FOOTER //
// ./src/components/pages/web/ListingListPage.js